import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@features/auth/model/use-auth';
import { FullPageSpinner } from '@shared/ui/Spinner';
import { DEFAULT_PATH } from '@app/router/paths';

/** Keeps an already-signed-in admin away from the login page. */
export function PublicOnlyRoute() {
  const { isAuthenticated, isRestoring } = useAuth();

  if (isRestoring) {
    return <FullPageSpinner label="Restoring your session" />;
  }

  if (isAuthenticated) {
    return <Navigate to={DEFAULT_PATH} replace />;
  }

  return <Outlet />;
}
